import { type Area } from 'react-easy-crop'
import { getOutputSize, getOutputType } from './utils'

const OUTPUT_QUALITY = 0.9

export const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', reject)
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = url
  })

export const getCroppedImg = async (imageSrc: string, pixelCrop: Area, sourceType: string | null, maxDimension = Infinity, minHeight = 0): Promise<Blob> => {
  const image = await createImage(imageSrc)
  const { width, height } = getOutputSize(pixelCrop.width, pixelCrop.height, maxDimension, minHeight)
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    throw new Error('Could not get canvas context')
  }
  ctx.imageSmoothingQuality = 'high'
  ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, width, height)
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Canvas is empty'))), getOutputType(sourceType), OUTPUT_QUALITY)
  })
}
